// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tips[data-v-e8309214] {\n  margin-bottom: 14px;\n  padding: 10px 12px;\n  background: #f8f8f9;\n  color: #606266;\n  font-size: 13px;\n  line-height: 1.7;\n}\n.sub-line[data-v-e8309214] {\n  color: #909399;\n  font-size: 12px;\n}\n.amount[data-v-e8309214] {\n  color: #f56c6c;\n  font-weight: 600;\n}\n.pager[data-v-e8309214] {\n  margin-top: 14px;\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
